import Cookies from "js-cookie";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";
import { TClaimChange, TClaimPost } from "../types/claim";

export async function getClaims() {
  try {
    const response = await fetch(`${BACKEND_URL}/complaints`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get claims:", error);
    throw error;
  }
}
export async function createClaims(commentId: TClaimPost) {
  try {
    const response = await fetch(`${BACKEND_URL}/complaints`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(commentId),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get claims:", error);
    throw error;
  }
}
export async function changeClaims(comment: TClaimChange) {
  try {
    const response = await fetch(`${BACKEND_URL}/complaints/action`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(comment),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get claims:", error);
    throw error;
  }
}
